import type { RemoteSelect } from 'liyu-pc-base/components/FormRender/RemoteSelect/typing';
import { useGlobMap } from 'liyu-pc-base/init-plugin';

const res_components: { [key: string]: any } = {};
const init = () => {
  if (Object.keys(res_components).length > 0) {
    return;
  }
  const allComponents: any = import.meta.glob(
    'liyu-pc-base/components/FormRender/RemoteSelect/configs/*/*.ts',
    {
      eager: true,
    },
  );
  const customComponents = useGlobMap('remoteSelect');
  Object.assign(allComponents, customComponents);
  Object.keys(allComponents).forEach(full_file_name => {
    const file_name_list = full_file_name.split('/');
    const file_name = file_name_list[file_name_list.length - 1].replace('.ts', '');
    res_components[file_name] = allComponents[full_file_name].default;
  });
};

export default (modalType: string): RemoteSelect => {
  init();
  if (res_components[modalType] == undefined) {
    console.error('remoteselect没有组件：' + modalType);
    return {
      getData: undefined,
      searchConfig: undefined,
    };
  }
  return {
    ...res_components[modalType](`remoteselect_${modalType}`),
  };
};
